module.exports = __webpack_public_path__ + "static/media/Truemoney_horizontal.2d86d5bc.svg";